var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6.45508C11 9.49264 8.53757 11.9551 5.5 11.9551C2.46243 11.9551 0 9.49264 0 6.45508C0 3.41751 2.46243 0.955078 5.5 0.955078C8.53757 0.955078 11 3.41751 11 6.45508ZM5.49952 7.1637C5.15381 7.1637 4.87095 6.9054 4.87095 6.58969V3.28917C4.87095 2.97347 5.15381 2.71517 5.49952 2.71517C5.84524 2.71517 6.1281 2.97347 6.1281 3.28917V6.58969C6.1281 6.9054 5.84524 7.1637 5.49952 7.1637ZM4.7143 8.74235C4.7143 9.21075 5.06608 9.59046 5.50002 9.59046C5.93396 9.59046 6.28573 9.21075 6.28573 8.74235C6.28573 8.27396 5.93396 7.89425 5.50002 7.89425C5.06608 7.89425 4.7143 8.27396 4.7143 8.74235Z",
    fill: "#DF553B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7bd5beddd670e3f94b0faba7f75f2f47.svg";
export { ForwardRef as ReactComponent };